const place_data_2020 = [
  { Name: "Aditya r gupta", Roll: "15BEC010", Company: "Almashine" },
  {
    Name: "Shah milap jayeshkumar",
    Roll: "15BEC181",
    Company: "D-tech solution integrators",
  },
  { Name: "Maniar aayushi nirav ", Roll: "16BEC002", Company: "Tcs ninja" },
  { Name: "Abhishek  paliwal", Roll: "16BEC004", Company: "E infochip" },
  { Name: "Abhishek  soni", Roll: "16BEC005", Company: "Arm embeded" },
  { Name: "Bajpai adhyan anil", Roll: "16BEC006", Company: "Bank of america" },
  { Name: "Parth sinha", Roll: "16BEC007", Company: "Cognizant" },
  {
    Name: "Aditi  bhatnagar",
    Roll: "16BEC008",
    Company: "Cypress semiconductor",
  },
  {
    Name: "Agravat mayur rajeshkumar",
    Roll: "16BEC009",
    Company: "Mantra softech",
  },
  { Name: "Ambasana kaushal shishirbhai", Roll: "16BEC011", Company: "Nvidia" },
  { Name: "Ronal khara", Roll: "16BEC013", Company: "Evosys" },
  { Name: "Poorva  gupta", Roll: "16BEC014", Company: "M.g motors" },
  { Name: "Avantika  sharma", Roll: "16BEC015", Company: "Cognizant" },
  { Name: "Babiya meet kishor", Roll: "16BEC016", Company: "Bank of america" },
  {
    Name: "Prajapati ajaykumar vinaykumar",
    Roll: "16BEC017",
    Company: "Amdocs",
  },
  { Name: "Prakhar   suneja", Roll: "16BEC019", Company: "Arm embeded" },
  {
    Name: "Pranjal  shrivastava",
    Roll: "16BEC020",
    Company: "Cypress semiconductor",
  },
  {
    Name: "Bodhanwala krishna kalpeshkumar",
    Roll: "16BEC021",
    Company: "L&t technology services",
  },
  {
    Name: "Prateek kamal gyanchandani",
    Roll: "16BEC022",
    Company: "Arm embeded",
  },
  { Name: "Rakshit  goyal", Roll: "16BEC026", Company: "Tcs" },
  {
    Name: "Fulja oza ",
    Roll: "16BEC027",
    Company: "National engineering industries",
  },
  {
    Name: "Sangtani darshan jagdish ",
    Roll: "16BEC029",
    Company: "Zs associate",
  },
  { Name: "Reshma  kandula", Roll: "16BEC030", Company: "Bank of america" },
  { Name: "Desai dhwani hetalbhai", Roll: "16BEC031", Company: "Qualcomm" },
  {
    Name: "Desai vinay atulbhai",
    Roll: "16BEC032",
    Company: "Juniper network india pvt ltd",
  },
  {
    Name: "Sinha devanshi  sanjeev  ",
    Roll: "16BEC033",
    Company: "Secure meter",
  },
  {
    Name: "Dhruv  mathur",
    Roll: "16BEC035",
    Company: "Infosys (higher study exam also given)",
  },
  {
    Name: "Saumya thacker",
    Roll: "16BEC036",
    Company: "Cadence design systems private limited",
  },
  {
    Name: "Thakkar hardi bhargavbhai ",
    Roll: "16BEC039",
    Company: "Tcs ninja",
  },
  { Name: "Shreejita chaudhuri", Roll: "16BEC045", Company: "Bank of america" },
  { Name: "Ishan  lakhwani", Roll: "16BEC046", Company: "Infosys" },
  { Name: "Shreya  adhikari", Roll: "16BEC047", Company: "Zs associate" },
  { Name: "Ms. ishita  kumawat", Roll: "16BEC048", Company: "Bank of america" },
  {
    Name: "Shreyansh  nayak",
    Roll: "16BEC049",
    Company: "Freelance online work ",
  },
  { Name: "Shreyansh  surana", Roll: "16BEC051", Company: "Cognizant" },
  { Name: "Jahnvi bedia", Roll: "16BEC052", Company: "Meditab" },
  { Name: "Simran  kathuria", Roll: "16BEC053", Company: "Aakash institute" },
  { Name: "Somil  kabra", Roll: "16BEC055", Company: "Zs associate" },
  {
    Name: "Jaya  thadhani",
    Roll: "16BEC056",
    Company: "National engineering industries",
  },
  { Name: "Sujaan  dubey", Roll: "16BEC057", Company: "Bank of america" },
  { Name: "Jayvik desai", Roll: "16BEC058", Company: "Cypress semiconductor" },
  { Name: "Saket lunker", Roll: "16BEC060", Company: "Bank of america" },
  { Name: "Jethva monil jayeshbhai", Roll: "16BEC062", Company: "E infochip" },
  { Name: "Jethwa himang kishorbhai", Roll: "16BEC063", Company: "Cognizant" },
  { Name: "Uttkarsh dinesh tak", Roll: "16BEC064", Company: "Matrix cosmec" },
  {
    Name: "Jobanputra ami",
    Roll: "16BEC065",
    Company: "M point consulting pvt ltd",
  },
  { Name: "Kadia harshil vinodkumar", Roll: "16BEC067", Company: "Amdocs" },
  {
    Name: "Kanojiya manavkumar mahendrabhai",
    Roll: "16BEC069",
    Company: "E infochip",
  },
  { Name: "Vidhi shah", Roll: "16BEC070", Company: "E infochip" },
  {
    Name: "Karan bhavesh shah",
    Roll: "16BEC071",
    Company: "Intel tech india pvt ltd",
  },
  { Name: "Vikani purval kishorbhai", Roll: "16BEC072", Company: "E infochip" },
  {
    Name: "Karan shah",
    Roll: "16BEC073",
    Company: "Collabera technologies pvt. ltd.",
  },
  { Name: "Naman khandelwal", Roll: "16BEC076", Company: "Hsbc" },
  { Name: "Priti khandelwal", Roll: "16BEC077", Company: "Arm embeded" },
  { Name: "Keshavkant sharma", Roll: "16BEC079", Company: "Lidar tech" },
  { Name: "Yogesh  maheshwari", Roll: "16BEC080", Company: "Nvidia" },
  { Name: "Kuhuk narain", Roll: "16BEC081", Company: "Mentor graphic pvt ltd" },
  { Name: "Mahesh chandak", Roll: "16BEC082", Company: "Zs associate" },
  {
    Name: "Makwana shreeya kiritbhai",
    Roll: "16BEC084",
    Company: "Provino technologies pvt ltd",
  },
  { Name: "Punit  malpani", Roll: "16BEC085", Company: "Cognex" },
  { Name: "Mehta meet kirankumar", Roll: "16BEC087", Company: "Infosys" },
  { Name: "Mishra saurabh sushil", Roll: "16BEC088", Company: "E infochip" },
  { Name: "Miti shah", Roll: "16BEC090", Company: "Tcs ninja" },
  {
    Name: "Modasiya mohmed safin mohmed yusuf",
    Roll: "16BEC091",
    Company: "Bank of america",
  },
  { Name: "Mohamad abrar i mansuri", Roll: "16BEC093", Company: "Cognizant" },
  {
    Name: "Muskan  porwal",
    Roll: "16BEC094",
    Company: "Provino technologies pvt ltd",
  },
  { Name: "Naman  goyal", Roll: "16BEC095", Company: "Amdocs" },
  {
    Name: "Nitesh  kalwani",
    Roll: "16BEC096",
    Company: "Cadence design systems private limited",
  },
  { Name: "Onima pandit", Roll: "16BEC097", Company: "Bank of america" },
  { Name: "Oshin  bansal", Roll: "16BEC098", Company: "Infosys" },
  {
    Name: "Pandya shiven hiteshbhai",
    Roll: "16BEC100",
    Company: "Cypress semiconductor",
  },
  { Name: "Rahul bansal", Roll: "16BEC101", Company: "Cognizant" },
  { Name: "Ayush jain", Roll: "16BEC102", Company: "E infochip" },
  { Name: "Sparsh yashlaha", Roll: "16BEC104", Company: "Searce" },
  {
    Name: "Arya pranjal vedruchibhai",
    Roll: "16BEC105",
    Company: "Cypress semiconductor",
  },
  {
    Name: "Issrani muskan darshan kumar",
    Roll: "16BEC106",
    Company: "Bank of america",
  },
  { Name: "Amin prerak ashish", Roll: "16BEC107", Company: "Byjus" },
  { Name: "Meet m patel", Roll: "16BEC108", Company: "Cognizant" },
  { Name: "Anmol jain", Roll: "16BEC109", Company: "Searce" },
  {
    Name: "Patel rutvik bipinchandra",
    Roll: "16BEC110",
    Company: "Government job",
  },
  {
    Name: "Utkarsh sunil agrawal",
    Roll: "16BEC111",
    Company: "Oracle india private limited",
  },
  { Name: "Gursimar hora", Roll: "16BEC112", Company: "Tcs ninja" },
  { Name: "Kamya ahuja", Roll: "16BEC113", Company: "E infochip" },
  { Name: "Rinali dipenbhai shah", Roll: "16BEC115", Company: "E infochip" },
  { Name: "Vithika mandhwani", Roll: "16BEC116", Company: "Tcs ninja" },
  { Name: "Mengar ronak deepakbhai", Roll: "16BEC117", Company: "Cognizant" },
  {
    Name: "Ramnani vinita jagdish",
    Roll: "16BEC118",
    Company: "Bank of america",
  },
  {
    Name: "Patel nishith nileshkumar",
    Roll: "16BEC119",
    Company: "E infochip",
  },
  { Name: "Patel meet manojkumar", Roll: "16BEC120", Company: "E infochip" },
  { Name: "Amipara parth rameshbhai", Roll: "16BEC121", Company: "Samsung" },
  { Name: "Talwar vivek jayant", Roll: "16BEC122", Company: "Cognizant" },
  { Name: "Nitin sharma", Roll: "16BEC123", Company: "E infochip" },
  { Name: "Bhatt mauli sanjaykumar", Roll: "16BEC124", Company: "Hsbc" },
  { Name: "Akhilesh sivadasan", Roll: "16BEC125", Company: "Auto ninja" },
  { Name: "Devika muley", Roll: "16BEC126", Company: "E infochip" },
  { Name: "Bharat aasija", Roll: "16BEC127", Company: "Intelqsolution" },
  { Name: "Candy brendon james", Roll: "16BEC129", Company: "Cognizant" },
  {
    Name: "Pancholi mrunal nileshkumar",
    Roll: "16BEC130",
    Company: "E infochip",
  },
  { Name: "Saluja karan sanjay", Roll: "16BEC174", Company: "Gd ajmera" },
  {
    Name: "Sumbhe ronak pravin",
    Roll: "16BEC178",
    Company: "Insync healthcare solution, vadodara ",
  },
];

export default place_data_2020;